import Vue from 'vue'
import './element-variables.scss'
import Element from 'element-ui'
import FbVueTemplate from 'fb-vue-template'
import 'fb-vue-template/lib/fb-vue-template.css'


Vue.use(Element, {
    size: 'small'
})


Vue.use(FbVueTemplate)
